import PropTypes from 'prop-types';
import compensationPropType from './compensation';

export default PropTypes.arrayOf(compensationPropType);
